import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-1 ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ eyebrow, title, text, className = "" }) => (
  <div className={`max-w-2xl ${className}`}>
    {eyebrow && (
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.22em] text-terracotta">{eyebrow}</p>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="mt-3 font-serif text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-forest">{title}</h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base sm:text-lg leading-relaxed text-pebble">{text}</p>
      </Reveal>
    )}
  </div>
);
